export const VIEWS = {
    CONTACT: 'CONTACT',
    CMB: 'CMB',
    CMB_REVOKE: 'CMBREVOKE',
    CHAT: 'CHAT',
    CHAT_SAVE: 'CHATSAVE',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    PRELOADER: 'PRELOADER',
    PREVIEW: 'PREVIEW',
    CLICK2CALL: 'CLICK2CALL',
    VISUALIVR: 'VISUALIVR'
};

export const VIEW_MODES = {
    MINIMIZED: 'MINIMIZED',
    MAXIMIZED: 'MAXIMIZED',
    POPUP: 'POPUP'
};
